module.exports = __webpack_public_path__ + "img/realisationMiniere.d6e3017c.jpg";